import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import withMobileDialog from '@material-ui/core/withMobileDialog'

import FormControl from '@material-ui/core/FormControl'
import TextField from '@material-ui/core/TextField'
//import Input from '@material-ui/core/Input'

import InputLabel from '@material-ui/core/InputLabel'
import Select from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'
import IconButton from '@material-ui/core/IconButton';
import EditIcon from '@material-ui/icons/Edit';
import ListIcon from '@material-ui/icons/List';

import { connect } from 'react-redux'

import { numberOfOptionsList } from '../utils/_DATA'
import t from '../utils/lang'

import { handleGetContacts } from '../actions/contacts'
import { handleSaveFlexData } from '../actions/rfp'
import { showSnackbar } from '../actions/snackbar'

const styles = theme => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    minWidth: '300px',
    maxWidth: '400px',
  },
  formControl: {
    margin: '0 0 10px',
    width: '100%'
  },
  currencyFormControl: {
    marginTop: '16px'
  },
  textField: {
    flexGrow: 1
  },
  editIcon: {
    height: '34px',
    borderRadius: 0,
    alignSelf: 'end',
    padding: theme.spacing.unit,
    marginLeft: theme.spacing.unit,
    '& svg': {
      width: '0.75em',
      height: '0.75em'
    }
  },
  listIcon: {
    height: '34px',
    width: '34px',
    borderRadius: 0,
    alignSelf: 'end',
    padding: theme.spacing.unit,
    marginLeft: theme.spacing.unit,
  }
});

class FlexGeneralInfoDialog extends Component {
  state = {
    numberOfOptions: '',
    contactPerson: '',
    customPerson: false
  }

  componentDidMount() {
    const { data, rfpId, onHandleGetContacts, contacts } = this.props

    onHandleGetContacts(rfpId).then(this.setState(() => ({
      numberOfOptions: data && data.numberOfOptions !== null ? data.numberOfOptions : '',
      contactPerson: data && data.contactPerson !== null ? data.contactPerson : '',
      customPerson: data && data.contactPerson !== null || !contacts || (contacts && contacts.map(el => el.name === data.contactPerson))
    })))
  }

  handleChangeNumberOfOptions = e => {
    const numberOfOptions = e.target.value

    this.setState(() => ({
      numberOfOptions
    }))
  }

  handleChangeContactPerson = e => {
    const contactPerson = e.target.value
    console.log(contactPerson)

    this.setState(() => ({
      contactPerson
    }))
  }

  handleSaveData = e => {
    const { rfpId, handleClose, onHandleSaveFlexData, showSnackbar, i18n } = this.props
    const data = JSON.stringify(this.state)

    onHandleSaveFlexData(rfpId, data).then(
      handleClose(),
      showSnackbar({ message: i18n.snackbar.changesSaved })
    )
  }

  toggleEditContactPerson = e =>
    this.setState({ customPerson: !this.state.customPerson });


  render() {
    const { fullScreen, open, handleClose, contacts, classes, i18n } = this.props
    const { numberOfOptions, contactPerson, customPerson } = this.state

    return (
      <div>
        <Dialog
          fullScreen={fullScreen}
          open={open}
          onClose={handleClose}
          aria-labelledby="responsive-dialog-title"
        >
          <DialogTitle id="responsive-dialog-title">{i18n.editGeneralInfo}</DialogTitle>
          <DialogContent>
            <form className={classes.root}>
              <FormControl className={classes.formControl}>
                <InputLabel htmlFor="numberOfOptions">{i18n.numberOfOptions}</InputLabel>
                <Select
                  id="numberOfOptions"
                  value={numberOfOptions}
                  onChange={this.handleChangeNumberOfOptions}
                  name="numberOfOptions"
                  //margin="normal"
                >
                  {numberOfOptionsList.map(option => (
                    <MenuItem key={option} value={option}>
                      {option}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              <FormControl className={classes.formControl}>
                <div style={{ display: 'flex' }}>
                  {customPerson
                    ? <TextField
                        id="contactPerson"
                        className={classes.textField}
                        label={i18n.contactPerson}
                        value={contactPerson}
                        onChange={this.handleChangeContactPerson}
                      />
                    : <TextField
                        select
                        id="contactPerson"
                        className={classes.textField}
                        label={i18n.contactPerson}
                        value={contactPerson}
                        onChange={this.handleChangeContactPerson}
                        // margin="normal"
                      >
                        {contacts.map(option => (
                          <MenuItem key={option.id} value={option.name}>
                            {option.name}
                          </MenuItem>
                        ))}
                      </TextField>
                  }
                  <IconButton className={customPerson ? classes.listIcon : classes.editIcon} onClick={this.toggleEditContactPerson}>
                    {customPerson ? <ListIcon /> : <EditIcon />}
                  </IconButton>
                </div>
              </FormControl>
            </form>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color="primary">
              {i18n.cancel}
            </Button>
            <Button onClick={this.handleSaveData} color="primary" autoFocus>
              {i18n.save}
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

FlexGeneralInfoDialog.propTypes = {
  fullScreen: PropTypes.bool.isRequired,
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
};

function mapStateToProps({ contacts, rfpData }) {
  const { lang, id, flexData } = rfpData

  return {
    i18n: t[lang],
    rfpId: id,
    data: JSON.parse(flexData.form),
    contacts: contacts ? Object.values(contacts) : []
  }
}

const mapDispatchToProps = dispatch => ({
  onHandleGetContacts: rfpId => dispatch(handleGetContacts(rfpId)),
  onHandleSaveFlexData: (rfpId, data) => dispatch(handleSaveFlexData(rfpId, data)),
  showSnackbar: options => dispatch(showSnackbar(options))
})

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(withMobileDialog()(FlexGeneralInfoDialog)))


// WEBPACK FOOTER //
// ./src/components/FlexGeneralInfoDialog.js